module.exports = __webpack_public_path__ + "img/rules_14.020e0a11.png";